<template>
  <div class="exam-content">
    <h3>2020迎“七•一”，党建知识竞赛</h3>
    <p>第九城市党总支</p>
    <p>为迎接建党99周年华诞，全面贯彻落实习近平新时代中国特色社会主义思想和党的十九大精神，创新学习方式，增强学习效果，保持党员、积极分子先进性，通过“七个一”活动提高九城党总支全体党员的凝聚力和历史使命感。</p>
    <h4 class="txt">竞赛说明：</h4>
    <p class="txt">
      1.输入真实姓名，点击【开始】进入竞赛；<br />
      2.根据“参考字数”输入相应答案；<br />
      3.本次竞赛共33题，按【下一题】继续答题<br />
      4.直至全对方可过关<br />
      5.根据答题用时排名，可多次答题争取更好成绩
    </p>
    <p>进入答题环节，并开始计时</p>
    <div class="userName">
      <van-field v-model="value"
                 label="姓名"
                 placeholder="请输入姓名" />
    </div>
    <p class="btn"
       @click="clickGo()">
      <a>开始答题</a>
    </p>
  </div>
</template>
<script>
import { Dialog } from 'vant';
export default {
  data () {
    return {
      value: ''
    }
  },
  methods: {
    clickGo: function () {
      if (this.value == '') {
        Dialog.alert({
          message: '请填写姓名',
        }).then(() => {
          // on close
        });
      } else {
        this.$router.push({ name: 'exam', params: { name: this.value } });
      }
    }
  }
}
</script>
<style scoped>
.exam-content {
  width: 90%;
  margin: 0 auto;
}

@media screen and (min-width: 700px) {
  .exam-content {
    width: 50%;
  }
}
.btn a {
  width: 100px;
  height: 40px;
  line-height: 40px;
  background-color: #07c160;
  display: inline-block;
  color: #fff;
  border-radius: 5px;
}
.txt {
  text-align: left;
}
</style>
<style>
.userName {
  margin: 0 auto;
  text-align: center;
  line-height: 40px;
}
@media screen and (min-width: 700px) {
  .userName {
    width: 80%;
  }
}
.userName .van-field__body > input.van-field__control {
  border: 1px solid #ddd;
  line-height: 40px;
}
.userName span {
  display: inline-block;
  line-height: 40px;
}
.userName .van-field__label {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue